import React, { useState, useContext, useEffect, useImperativeHandle, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useLocation, useNavigate } from "react-router-dom";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import Card from "@mui/material/Card";
import Avatar from "@mui/material/Avatar";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";

import Checkbox from "@mui/material/Checkbox";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NumbersIcon from "@mui/icons-material/Numbers";
import DeleteIcon from "@mui/icons-material/Delete";

import toast from "react-hot-toast";

import api from "services/api";
import moment from "moment";
import { capitalCase } from "capital-case";

import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt from "components/UpStyled/Prompt";

import { compare } from "utils/helper";
import { Spin, Empty } from "antd";
import colors from "assets/theme/base/colors";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";

import { moodboardSortOptions } from "utils/data";
import SearchIcon from "@mui/icons-material/Search";
import SortIcon from "@mui/icons-material/Sort";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SuiInput from "components/SuiInput";
import ListSubheader from "@mui/material/ListSubheader";

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? "rgba(255, 255, 255, .05)" : "rgba(0, 0, 0, .03)",
  flexDirection: "row",
  borderBottom: "1px solid rgba(0, 0, 0, .125)",
  minHeight: 30,
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
  "& .MuiAccordionSummary-content.Mui-expanded": {
    margin: "0",
  },
}));

const PostFileList = ({ handleClick = () => {}, currentItemId, handleRefresh = () => {} }) => {
  const [posts, setPosts] = useState([]);
  const [filteredAILabs, setFilteredAILabs] = useState([]);
  const [itemDetail, setItemDetail] = useState();
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState("draft");

  const [sortObj, setSortObj] = useState(moodboardSortOptions[0]);
  const [searchStr, setSearchStr] = useState();
  const [sortAnchorEl, setSortAnchorEl] = useState(null);

  useEffect(() => {
    retrieveAILabs();
  }, []);

  const retrieveAILabs = async () => {
    try {
      setLoading(true);

      const { data } = await api.post.list();
      let myPost = data?.posts || [];
      myPost = myPost.sort((a, b) => compare(a, b, "-updated_at"));

      setPosts(myPost);
      setFilteredAILabs(myPost);
      setLoading(false);
    } catch (err) {
      toast.error(`Retrieve posts failed!`);
      setLoading(false);

      console.log(err);
    }
  };

  const loadAILab = async (id) => {
    try {
      setLoading(true);

      const { data } = await api.post.retrieve(id);
      setItemDetail(data.post);

      setLoading(false);
    } catch (err) {
      toast.error(`Load posts failed!`);
      console.log(err);
      setLoading(false);
    }
  };
  const handleChangePanel = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setSortObj(moodboardSortOptions[0]);
    handleSearchFiles("");
    setSearchStr("");
  };

  const handleSearchChange = (str) => {
    setSearchStr(str);
    handleSearchFiles(str);
  };

  const handleSearchFiles = (search = searchStr, sort = sortObj) => {
    if (search) {
      const strUpper = search.toUpperCase();
      const searchFields = ["name", "title"];
      const searchResults = posts.filter((x) => {
        let result = false;
        for (let i = 0; i < searchFields.length; i++) {
          if (x[searchFields[i]]) {
            if (typeof x[searchFields[i]] == "string") {
              if (x[searchFields[i]].toUpperCase().includes(strUpper)) {
                result = true;
              }
            } else if (typeof x[searchFields[i]] == "object") {
              const text = JSON.stringify(x[searchFields[i]]);
              if (text.toUpperCase().includes(strUpper)) {
                result = true;
              }
            }
          }
        }
        return result;
      });

      let sortedList = searchResults.sort((a, b) => compare(a, b, sort.value));

      setFilteredAILabs(sortedList);
    } else {
      let sortedList = posts.sort((a, b) => compare(a, b, sort.value));

      setFilteredAILabs(sortedList);
    }
  };

  const handleCloseSortMenu = () => {
    setSortAnchorEl(null);
  };

  const SortMenu = () => (
    <Menu
      id="basic-menu"
      anchorEl={sortAnchorEl}
      open={Boolean(sortAnchorEl)}
      onClose={handleCloseSortMenu}
    >
      {moodboardSortOptions.map((x) => (
        <MenuItem
          onClick={() => {
            setSortObj(x);
            handleSearchFiles(searchStr, x);
            handleCloseSortMenu();
          }}
        >
          {x.label}
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <Card sx={{ borderRadius: 1 }}>
      <Spin
        indicator={<CircularProgress color="info" sx={{ mr: 1 }} size={32} />}
        spinning={loading}
      >
        {["draft", "published"].map((status) => (
          <Accordion
            style={{ margin: 0 }}
            expanded={expanded === status}
            onChange={handleChangePanel(status)}
          >
            <AccordionSummary
              aria-controls="panel1a-content"
              id={`panel1a-header-${status}`}
              sx={{ backgroundColor: "#efefef", py: 0 }}
              style={{ margin: 0, height: 45, minHeight: 45 }}
            >
              {status}
            </AccordionSummary>
            <AccordionDetails sx={{ px: 0, mx: 0 }}>
              <List
                dense
                sx={{
                  width: "100%",
                  maxWidth: 360,
                  maxHeight: 600,
                  overflow: "auto",
                  bgcolor: "background.paper",
                }}
                subheader={
                  <ListSubheader
                    component="div"
                    sx={{ display: "flex", gap: 0.5, width: "100%", px: 0.5 }}
                  >
                    <SuiBox>
                      <SuiInput
                        placeholder="Search Keywords"
                        type="text"
                        onChange={(e) => handleSearchChange(e?.target?.value)}
                        value={searchStr}
                        size="small"
                        icon={{
                          direction: "right",
                          component: (
                            <SearchIcon
                              sx={{ cursor: "pointer" }}
                              onClick={() => handleSearchChange(searchStr)}
                            />
                          ),
                        }}
                      />
                    </SuiBox>

                    <IconButton
                      aria-label="sort"
                      color="dark"
                      onClick={(e) => {
                        setSortAnchorEl(e.target);
                      }}
                    >
                      <SortIcon />
                    </IconButton>

                    <SortMenu />
                  </ListSubheader>
                }
              >
                {filteredAILabs
                  .filter((item) => item.status == status)
                  .map((item, index) => {
                    const labelId = `checkbox-list-secondary-label-${index}`;
                    return (
                      <ListItem
                        key={index}
                        secondaryAction={
                          <IconButton
                            aria-label="delete"
                            onClick={() => {
                              setSelectedItem(item);
                              setDeleteVisible(true);
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        }
                        disablePadding
                      >
                        <ListItemButton
                          onClick={() => {
                            setConfirmVisible(true);
                            loadAILab(item.id);
                          }}
                          sx={{
                            backgroundColor:
                              currentItemId == item.id ? colors.light.focus : "transparent",
                          }}
                        >
                          <ListItemAvatar
                            sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                          >
                            <SuiBox
                              sx={{
                                borderRadius: ({ borders }) => borders.borderRadius.md,
                                overflow: "hidden",
                                mr: 1,
                              }}
                            >
                              <ImageCardWrapper
                                resizeLimit={0}
                                data={item?.metadata?.coverImage}
                                height={50}
                                width={50}
                                style={{
                                  height: "auto",
                                  maxHeight: 50,
                                  width: "100%",
                                }}
                                sx={{
                                  display: "flex",
                                }}
                                draggable={false}
                              />
                            </SuiBox>
                          </ListItemAvatar>
                          <ListItemText
                            id={labelId}
                            primary={item.title}
                            secondary={moment(item.created_at).format("MM/DD/yyyy")}
                          />
                        </ListItemButton>
                      </ListItem>
                    );
                  })}
              </List>
            </AccordionDetails>
          </Accordion>
        ))}

        {deleteVisible && selectedItem?.id ? (
          <Prompt
            heading="Delete design file"
            text={`Are you sure you want to delete: ${selectedItem.name}?`}
            visible={deleteVisible}
            okText="Delete"
            okColor="error"
            handleOk={() => {
              api.post
                .delete(selectedItem.id)
                .then(() => {
                  toast.success(`Delete ${selectedItem.name} successfully!`);

                  setFilteredAILabs((prev) => prev.filter((x) => x.id != selectedItem.id));
                  setDeleteVisible(false);

                  const pathnames = window.location.pathname.split("/");
                  let post_id = null;
                  if (pathnames.length > 1 && pathnames[pathnames.length - 2] == "edit-post") {
                    post_id = pathnames[pathnames.length - 1];
                    let newUrl = pathnames.slice(0, pathnames.length - 1).join("/");
                    if (selectedItem.id == post_id) {
                      window.history.replaceState("", "Fashion Lab", newUrl);
                      handleRefresh();
                    }
                  }
                })
                .catch((err) => {
                  console.log(err);
                  toast.error(`Delete ${selectedItem.name} failed!`);
                });
            }}
            handleClose={() => setDeleteVisible(false)}
          />
        ) : null}
        {confirmVisible && itemDetail?.id ? (
          <Prompt
            heading="Switch working file"
            option={{
              maxWidth: "md",
            }}
            text={
              <SuiBox>
                <SuiTypography sx={{ mb: 1 }} variant="body1">
                  Are you sure you want to switch the current working file to{" "}
                  <strong>{itemDetail.title}</strong>?
                </SuiTypography>
                <SuiBox display="flex" justifyContent="space-between" gap={2} width="100%">
                  <SuiBox
                    sx={{
                      borderRadius: ({ borders }) => borders.borderRadius.md,
                      overflow: "hidden",
                      mx: "auto",
                      width: 320,
                      minWidth: 320,
                      position: "relative",
                    }}
                  >
                    <ImageCardWrapper
                      resizeLimit={0}
                      data={itemDetail?.metadata?.coverImage}
                      height={400}
                      width={320}
                      style={{
                        height: "auto",
                        maxHeight: 320,
                        width: "100%",
                      }}
                      sx={{
                        display: "flex",
                      }}
                      draggable={false}
                    />
                  </SuiBox>
                </SuiBox>
              </SuiBox>
            }
            visible={confirmVisible}
            okText="Confirm"
            okColor="info"
            handleOk={() => {
              handleClick(itemDetail);
              setConfirmVisible(false);
              setItemDetail(null);
            }}
            handleClose={() => {
              setConfirmVisible(false);
              setItemDetail(null);
            }}
          />
        ) : null}
      </Spin>
    </Card>
  );
};
export default PostFileList;
